module.exports = __webpack_public_path__ + "img/1.11491d99.png";